module.exports = __webpack_public_path__ + "static/media/cervejaria.bbf669b6.svg";